/**
 * @generated SignedSource<<34de7da99f0006e94754dd590c6724b9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ViewPageConversation_focusedInlineCommentContext$data = {
  readonly focusedContent: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly operations: ReadonlyArray<{
        readonly operation: string | null;
        readonly targetType: string | null;
      } | null> | null;
      readonly space: {
        readonly id: string | null;
        readonly operations: ReadonlyArray<{
          readonly operation: string | null;
          readonly targetType: string | null;
        } | null> | null;
      } | null;
      readonly type: string | null;
    } | null> | null;
  } | null;
  readonly user: {
    readonly displayName: string | null;
    readonly id: string | null;
    readonly photos: ReadonlyArray<{
      readonly isPrimary: boolean | null;
      readonly value: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "ViewPageConversation_focusedInlineCommentContext";
};
export type ViewPageConversation_focusedInlineCommentContext$key = {
  readonly " $data"?: ViewPageConversation_focusedInlineCommentContext$data;
  readonly " $fragmentSpreads": FragmentRefs<"ViewPageConversation_focusedInlineCommentContext">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "pageId"
    }
  ],
  "kind": "Fragment",
  "name": "ViewPageConversation_focusedInlineCommentContext",
  "selections": [
    {
      "alias": "focusedContent",
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "pageId"
        }
      ],
      "concreteType": "PaginatedContentListWithChild",
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "concreteType": "Content",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "type"
            },
            {
              "concreteType": "Space",
              "kind": "LinkedField",
              "name": "space",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/)
              ]
            },
            (v1/*: any*/)
          ]
        }
      ]
    },
    {
      "alias": "user",
      "args": [
        {
          "kind": "Literal",
          "name": "current",
          "value": true
        }
      ],
      "concreteType": "AtlassianUser",
      "kind": "LinkedField",
      "name": "confluence_atlassianUser",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "displayName"
        },
        {
          "concreteType": "AtlassianUserPhoto",
          "kind": "LinkedField",
          "name": "photos",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "value"
            },
            {
              "kind": "ScalarField",
              "name": "isPrimary"
            }
          ]
        }
      ],
      "storageKey": "confluence_atlassianUser(current:true)"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "ddb1698b02dde6247368f7bab97ffc0a";

export default node;
